import { Pencil } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/Dialog";

import { useState } from "react";
import { Allocation } from "@/api/SolarCloudApi";
import { useEnergyCompanies } from "@/queries/useEnergyCompanies";
import UpdateAllocationForm from "./UpdateAllocationForm";
import LoadingSection from "@/components/LoadingSection";

type UpdateAllocationDialogProps = {
  handleUpdateAllocation: (allocation: Allocation) => void;
  unallocatedWatts: number;
  allocation: Allocation;
  account: "gas" | "electricity" | "bank" | undefined;
};

export default function UpdateAllocationDialog({
  handleUpdateAllocation,
  unallocatedWatts,
  allocation,
  account,
}: UpdateAllocationDialogProps) {
  const { data: energyCompanies } = useEnergyCompanies();
  const [isOpen, setIsOpen] = useState(false);

  const handleFormSubmit = (data: Allocation) => {
    setIsOpen(false);
    handleUpdateAllocation(data);
  };
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger>
        <div className="size-10 flex items-center justify-center bg-black rounded-lg border border-transparent hover:border-brand-orange-500">
          <Pencil className="size-6 text-brand-orange-500" />
        </div>
      </DialogTrigger>
      <DialogContent className="bg-brand-neutral-800 md:w-[600px] overflow-y-scroll max-h-screen">
        <div className="w-full md:w-sm mx-auto flex flex-col gap-y-4 py-6">
          <DialogHeader>
            <DialogTitle className="capitalize">Update Link </DialogTitle>
            <DialogDescription>
              Update the details of your link.
            </DialogDescription>
          </DialogHeader>
          {energyCompanies ? (
            <UpdateAllocationForm
              energyCompanies={energyCompanies}
              unallocatedWatts={unallocatedWatts + allocation.wattCapacity!}
              allocation={allocation}
              onUpdate={handleFormSubmit}
              onCancel={() => setIsOpen(false)}
              account={account}
            />
          ) : (
            <LoadingSection />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
